import { formatCurrencyAmountOrMasked } from "shared/money/balances";
import type { GroupTransaction } from "types/GroupTransaction";

export const MONEY_EPSILON = 0.01;

export function signedAmountLabel(
    amount: number,
    currency: string,
    visible: boolean,
    locale: string,
    sign?: "+" | "-",
): string {
    const formatted = formatCurrencyAmountOrMasked(Math.abs(amount), currency, visible, locale);
    if (!visible || !sign) return formatted;
    return `${sign} ${formatted}`;
}

export function primaryCurrencyForTransactions(transactions: GroupTransaction[], fallback: string): string {
    const totals = new Map<string, { count: number; amount: number }>();
    for (const tx of transactions) {
        const currency = tx.currency || "ARS";
        const current = totals.get(currency) ?? { count: 0, amount: 0 };
        current.count += 1;
        current.amount += Math.abs(Number(tx.amount) || 0);
        totals.set(currency, current);
    }

    const [primary] = [...totals.entries()].sort(([, a], [, b]) => {
        if (b.count !== a.count) return b.count - a.count;
        return b.amount - a.amount;
    });

    return primary?.[0] ?? fallback;
}

export function displayCurrencyForBalance(
    balancesByCurrency: Record<string, number> | undefined,
    groupPrimaryCurrency: string,
    fallback: string,
): string {
    const activeCurrencies = Object.entries(balancesByCurrency ?? {})
        .filter(([, amount]) => Math.abs(Number(amount) || 0) > MONEY_EPSILON)
        .map(([currency]) => currency);

    if (activeCurrencies.length === 1) return activeCurrencies[0];
    if (activeCurrencies.length === 0) return groupPrimaryCurrency;
    return fallback;
}
